module.exports = __webpack_public_path__ + "img/LuojiaSwarm1.0e97c85b.png";